// Ocean Insight Pro Mobile - App Redux Slice

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataFreshness } from '../types';

// Define the app state interface
interface AppState {
  isOnline: boolean;
  cacheStatus: {
    weather: DataFreshness;
    oceanographic: DataFreshness;
    fishing: DataFreshness;
  };
  lastSync: string | null;
}

// Initial state
const initialState: AppState = {
  isOnline: true, // Assume online initially
  cacheStatus: {
    weather: 'expired',
    oceanographic: 'expired',
    fishing: 'expired',
  },
  lastSync: null,
};

// App slice
const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setOnlineStatus: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload;
    },
    updateCacheStatus: (
      state,
      action: PayloadAction<{
        dataType: 'weather' | 'oceanographic' | 'fishing';
        status: DataFreshness;
      }>
    ) => {
      state.cacheStatus[action.payload.dataType] = action.payload.status;
    },
    setLastSync: (state, action: PayloadAction<string>) => {
      state.lastSync = action.payload;
    },
    resetAppState: (state) => {
      state.cacheStatus = {
        weather: 'expired',
        oceanographic: 'expired',
        fishing: 'expired',
      };
      state.lastSync = null;
    },
  },
});

export const { setOnlineStatus, updateCacheStatus, setLastSync, resetAppState } = appSlice.actions;

export default appSlice.reducer;
